<template>
  <v-autocomplete
    color="primary"
    hide-no-data
    v-model="stockPositionSelected"
    :clearable="!unclearable"
    :items="positionItems"
    :loading="Loading"
    :search-input.sync="search"
    item-text="position_name"
    item-value="id"
    item-disabled="disabled"
    :label="noLabel ? '' : $t('CurrentPosition.Fields.position')"
    return-object
    :single-line="dense"
    :dense="dense"
    :hide-details="dense"
    :style="dense ? 'margin-left: auto; margin-right: auto' : ''"
    :error-messages="errorMessages"
  ></v-autocomplete>
</template>

<script>
import stockPosition from "@/api/stock_position";

export default {
  name: "SearcherPosition",

  props: {
    value: Object,
    noLabel: Boolean,
    dense: Boolean,
    unclearable: Boolean,
    disabledItems: Array,
    errorMessages: Array,
    stockId: Number,
  },

  computed: {
    positionItems() {
      return this.stock_positions.map((e) => {
        const disabled = this.disabledItems
          ? this.disabledItems.find((disabledItem) => disabledItem.id == e.id)
          : false;
        return Object.assign({}, e, { disabled });
      });
    },
  },

  data: () => ({
    stock_positions: [],
    Loading: false,
    search: "",
    stockPositionSelected: null,
  }),

  mounted() {
    this.getStockPositionFromAPI();
  },

  methods: {
    getStockPositionFromAPI() {
      this.Loading = true;
      stockPosition
        .fetchAllForSelect({stock_id:this.stockId})
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.stock_positions = response.data.stock_positions;
              if(this.$route.params.id){
                let result = this.stock_positions.filter((v) => {
                  return v.id == this.$route.params.id;
                });
                this.stockPositionSelected = result[0];
              }
            }
            this.Loading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.Loading = false;
          }.bind(this)
        );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.stockPositionSelected = this.value;
      },
    },
    stockPositionSelected: {
      handler() {
        this.$emit("input", this.stockPositionSelected);
      },
    },
  },
};
</script>
